@if (isVisible) {
  <div class="indicator">
    @if (!value) {
      <div class="indeterminate"></div>
    }
    <!--	<div *ngIf="value" class="value" [ngStyle]="{ 'width.%': value }"></div>-->
  </div>
}
